import { Component, OnInit, HostListener, TemplateRef } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { TranslateService } from '@ngx-translate/core';
import { BsModalRef, BsModalService } from 'ngx-bootstrap/modal';
import { DeviceDetectorService } from 'ngx-device-detector';
import { ToastrService } from 'ngx-toastr';
import { ConfirmationService } from 'primeng/api';
import { AuthService } from 'src/services/guard/auth.service';
import { LinkService } from 'src/services/link.service';
import { LinkModel } from '../../models/link';
import { BaseComponent } from '../base/base.component';

@Component({
  selector: 'app-links',
  templateUrl: './links.component.html',
  styleUrls: ['./links.component.scss']
})
export class LinksComponent extends BaseComponent implements OnInit {

  allLinks: LinkModel[];
  links: LinkModel[][] = [];
  isAdmin: boolean;
  modalRef: BsModalRef;
  linkModel: LinkModel;
  numberOfColumns = 4;

  constructor(
    private linkService: LinkService,
    protected translate: TranslateService,
    protected authService: AuthService,
    private modalService: BsModalService,
    private toast: ToastrService,
    private confirm: ConfirmationService,
    deviceDetectorService: DeviceDetectorService,
    route: ActivatedRoute
  ) {
    super(translate, authService, deviceDetectorService, route);
  }

  ngOnInit(): void {
    this.linkModel = new LinkModel();
    this.linkService.getLinks().subscribe(
      data => {
        this.allLinks = data;
        this.initColumns();
      }
    );
  }

  @HostListener('window:resize', ['$event'])
  initColumns() {
    this.links = [];

    if (this.isDesktop) {
      this.numberOfColumns = 4;
    }

    if (this.isTablet) {
      this.numberOfColumns = 3;
    }

    if (this.isMobile) {
      this.numberOfColumns = 1;
    }

    for (let i = 0; i < this.numberOfColumns; i++) {
      this.links.push([]);
    }

    let currentRow = 0;
    for (let j = 0; j < this.allLinks.length; j++) {
      let index = j % this.numberOfColumns;
      if (j !== 0 && index === 0) {
        currentRow++;
      }
      this.links[index][currentRow] = this.allLinks[j];
    }
  }

  openLink(link: LinkModel) {
    window.open(link.link, '_blank');
  }

  getLinkProperty(link: LinkModel, property: string) {
    const lang = this.translate.currentLang.charAt(0).toUpperCase() + this.translate.currentLang.slice(1);
    return link[property + lang];
  }

  modalLink(template: TemplateRef<any>, link: LinkModel = null) {
    if (!this.isAdmin) {
      return;
    }
    this.linkModel = new LinkModel();
    if (link) {
      this.linkModel = Object.assign({}, link);
    }
    this.modalRef = this.modalService.show(template);
  }

  saveLink() {
    if (this.linkModel.id) {
      this.linkService.updateLink(this.linkModel).subscribe(
        () => this.toast.success('Link saved!'),
        err => {
          console.error(err);
          this.toast.error('An error occured!');
        },
        () => {
          this.ngOnInit();
          this.modalRef.hide();
        }
      );
    } else {
      this.linkService.addLink(this.linkModel).subscribe(
        () => this.toast.success('Link saved!'),
        err => {
          console.error(err);
          this.toast.error('An error occured!');
        },
        () => {
          this.ngOnInit();
          this.modalRef.hide();
        }
      );
    }
  }

  deleteLink() {
    this.confirm.confirm({
      message: 'Are you Sure?',
      accept: () => {
        this.linkService.deleteLink(this.linkModel).subscribe(
          data => this.toast.success('Link deleted!'),
          err => console.log(err),
          () => {
            this.modalRef.hide();
            this.ngOnInit();
          }
        );
      }
    });
  }

  close() {
    this.modalRef.hide();
  }

}
